import { TbArrowBigUp } from "react-icons/tb";
import { COLOR_SECOND, COLOR_SURFACE } from "../../../commons/LaColors";

const UpvoteNotClicked = () => {
  return (
    <TbArrowBigUp
      size={34}
      color={COLOR_SECOND}
      style={{
        padding: "7px",
        background: COLOR_SURFACE,
        borderRadius: "50%",
        border: `1.2px solid ${COLOR_SECOND}`,
      }}
    />
  );
};

export default UpvoteNotClicked;
